module.exports = __webpack_public_path__ + "img/pgtry.c2d678c9.png";